/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-close[_ngcontent-%COMP%] {\n  background-color: none !important;\n  border-color: #02008a; }\n\n.box-choice[_ngcontent-%COMP%] {\n  background: #FFFFFF;\n  padding: 2rem !important;\n  border-radius: 10px;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n@media (max-width: 992px) {\n  .top-margin[_ngcontent-%COMP%] {\n    margin-top: 20px; } }\n\ninput[type=radio][_ngcontent-%COMP%] {\n  width: 1.75em;\n  height: 1.75em;\n  accent-color: #02008a; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.component.scss.shim.ngstyle.js.pre-build-optimizer.js